import { FC } from 'react'

interface CloseIconProps {
  isMobile?: boolean
}

export const CloseIcon: FC<CloseIconProps> = (props) => {
  const { isMobile } = props

  if (isMobile) {
    return (
      <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L16 14.5858L26.2929 4.29289C26.6834 3.90237 27.3166 3.90237 27.7071 4.29289C28.0976 4.68342 28.0976 5.31658 27.7071 5.70711L17.4142 16L27.7071 26.2929C28.0976 26.6834 28.0976 27.3166 27.7071 27.7071C27.3166 28.0976 26.6834 28.0976 26.2929 27.7071L16 17.4142L5.70711 27.7071C5.31658 28.0976 4.68342 28.0976 4.29289 27.7071C3.90237 27.3166 3.90237 26.6834 4.29289 26.2929L14.5858 16L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z'
          fill='currentColor'
        />
      </svg>
    )
  }

  return (
    <svg width='48' height='49' viewBox='0 0 48 49' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.2045 5.7045C5.64384 5.26517 6.35616 5.26517 6.7955 5.7045L24 22.909L41.2045 5.7045C41.6438 5.26517 42.3562 5.26517 42.7955 5.7045C43.2348 6.14384 43.2348 6.85616 42.7955 7.2955L25.591 24.5L42.7955 41.7045C43.2348 42.1438 43.2348 42.8562 42.7955 43.2955C42.3562 43.7348 41.6438 43.7348 41.2045 43.2955L24 26.091L6.7955 43.2955C6.35616 43.7348 5.64384 43.7348 5.2045 43.2955C4.76517 42.8562 4.76517 42.1438 5.2045 41.7045L22.409 24.5L5.2045 7.2955C4.76517 6.85616 4.76517 6.14384 5.2045 5.7045Z'
        fill='currentColor'
      />
    </svg>
  )
}
